'use strict';

export default {
  tasks: 'tasks'
}
